import { Box, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import "./SPFormButton.scss";
import { useSelector } from "react-redux";
function SPFormButton({ ...props }) {
  const { showSuccessPopUp, disabledBttn, errorMsg, dispError, spPageText } = useSelector((state: any) => state.sellerProfile);

  const { label } = props;

  let setDisabled = disabledBttn.hasOwnProperty(props.formName)
    ? disabledBttn[props.formName]
    : true;

  if (props.disabled !== undefined) {
    setDisabled = setDisabled || props.disabled;
  }

  let errorMessage;

  if (errorMsg && dispError !== undefined) {
    errorMessage = spPageText[`error${dispError.err_code}`]
  } else {
    errorMessage = errorMsg
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      {errorMsg !== "" && (
        <Box className="formButtonContainer">
          <output>{errorMessage} </output>
        </Box>
      )}
      {showSuccessPopUp !== "" && (
        <Box className="successScreenReader">
          <output>{errorMsg} </output>
        </Box>
      )}
      {props.showLoading ? (
        <LoadingButton loading className="spButton loading">
          {" "}
          {label}
        </LoadingButton>
      ) : (
        <Button
          sx={{
            '&:hover': {
              backgroundColor: '#003d78 !important',
              color: '#fff !important'
            }
          }}
          className={`spButton ${props.compName}`}
          onClick={() => props.handleClick()}
          disabled={setDisabled}
        >
          {label}
        </Button>
      )}
    </Box>
  );
}

export default SPFormButton;
